import apiClient from './client'

/**
 * API per gestione ordini
 */

// Ordini
export const getOrdini = (params) => apiClient.get('/orders/ordini/', { params })
export const getOrdine = (id) => apiClient.get(`/orders/ordini/${id}/`)
export const createOrdine = (data) => apiClient.post('/orders/ordini/', data)
export const updateOrdine = (id, data) => apiClient.patch(`/orders/ordini/${id}/`, data)
export const deleteOrdine = (id) => apiClient.delete(`/orders/ordini/${id}/`)

// Actions ordini
export const confermaOrdine = (id) => apiClient.post(`/orders/ordini/${id}/conferma/`)
export const annullaOrdine = (id, causale) => apiClient.post(`/orders/ordini/${id}/annulla/`, { causale })
export const cambiaStatoOrdine = (id, data) => apiClient.post(`/orders/ordini/${id}/cambia_stato/`, data)
export const stampaOrdine = (id) => apiClient.get(`/orders/ordini/${id}/stampa/`)
export const getStatisticheOrdini = (params) => apiClient.get('/orders/ordini/statistiche/', { params })
export const getStatiOrdine = () => apiClient.get('/orders/ordini/stati/')
export const salvaComeBox = (id, data) => apiClient.post(`/orders/ordini/${id}/salva_come_box/`, data)
export const verificaSpedizioneOrdine = (id) => apiClient.get(`/orders/ordini/${id}/verifica_spedizione/`)

// Righe ordine
export const aggiungiRiga = (ordineId, data) => apiClient.post(`/orders/ordini/${ordineId}/aggiungi_riga/`, data)
export const rimuoviRiga = (ordineId, rigaId) => apiClient.delete(`/orders/ordini/${ordineId}/righe/${rigaId}/`)
export const getRighe = (params) => apiClient.get('/orders/righe/', { params })

// Spedizioni
export const getSpedizioni = (params) => apiClient.get('/orders/spedizioni/', { params })
export const getSpedizioniLista = (params) => apiClient.get('/orders/spedizioni/lista/', { params })
export const getSpedizione = (id) => apiClient.get(`/orders/spedizioni/${id}/`)
export const createSpedizione = (data) => apiClient.post('/orders/spedizioni/', data)
export const updateSpedizione = (id, data) => apiClient.patch(`/orders/spedizioni/${id}/`, data)
export const deleteSpedizione = (id) => apiClient.delete(`/orders/spedizioni/${id}/`)
export const cambiaStatoSpedizione = (id, stato) => apiClient.post(`/orders/spedizioni/${id}/cambia_stato/`, { stato })
export const confermaRientroSpedizione = (id, causale) => apiClient.post(`/orders/spedizioni/${id}/conferma-rientro/`, { causale })
export const emettiDdtSpedizione = (id, dataSpedizione) => apiClient.post(
  `/orders/spedizioni/${id}/ddt/`,
  { data_spedizione: dataSpedizione },
  { responseType: 'blob' },
)
export const scaricaDdtSpedizione = (id) => apiClient.get(`/orders/spedizioni/${id}/ddt/`, { responseType: 'blob' })

// Pagamenti
export const getPagamenti = (params) => apiClient.get('/orders/pagamenti/', { params })
export const getPagamento = (id) => apiClient.get(`/orders/pagamenti/${id}/`)
export const createPagamento = (data) => apiClient.post('/orders/pagamenti/', data)
export const updatePagamento = (id, data) => apiClient.patch(`/orders/pagamenti/${id}/`, data)
export const deletePagamento = (id) => apiClient.delete(`/orders/pagamenti/${id}/`)
export const annullaPagamento = (id, data) => apiClient.post(`/orders/pagamenti/${id}/annulla/`, data)

// ============================================================================
// FASE 7.4: Spedizioni Avanzate - Destinatari e Colli
// ============================================================================

// Destinatari
export const getDestinatari = (params) => apiClient.get('/orders/destinatari/', { params })
export const getDestinatario = (id) => apiClient.get(`/orders/destinatari/${id}/`)
export const createDestinatario = (data) => apiClient.post('/orders/destinatari/', data)
export const updateDestinatario = (id, data) => apiClient.patch(`/orders/destinatari/${id}/`, data)
export const deleteDestinatario = (id) => apiClient.delete(`/orders/destinatari/${id}/`)
export const searchDestinatari = (query) => apiClient.get('/orders/destinatari/search/', { params: { q: query } })
export const creaDestinatarioDaCliente = (clienteId) => apiClient.post('/orders/destinatari/crea_da_cliente/', { cliente_id: clienteId })

// Colli
export const getColli = (params) => apiClient.get('/orders/colli/', { params })
export const getCollo = (id) => apiClient.get(`/orders/colli/${id}/`)
export const createCollo = (data) => apiClient.post('/orders/colli/', data)
export const updateCollo = (id, data) => apiClient.patch(`/orders/colli/${id}/`, data)
export const deleteCollo = (id) => apiClient.delete(`/orders/colli/${id}/`)

// Wizard Spedizioni - Creazione transazionale completa
export const createSpedizioneWizard = (data) => apiClient.post('/orders/spedizioni/create-wizard/', data)

// Wizard Spedizioni - Calcolo peso suggerito dai contenuti
export const calcolaPesoColli = (data) => apiClient.post('/orders/spedizioni/calcola-peso-colli/', data)

// Allegati ordine (Punto 15 feedback cliente)
export const getAllegatiOrdine = (ordineId) =>
  apiClient.get(`/orders/ordini/${ordineId}/allegati/`)

export const uploadAllegatoOrdine = (ordineId, formData) =>
  apiClient.post(`/orders/ordini/${ordineId}/allegati/`, formData)

export const deleteAllegatoOrdine = (ordineId, allegatoId) =>
  apiClient.delete(`/orders/ordini/${ordineId}/allegati/${allegatoId}/`)

export const downloadAllegatoOrdine = (ordineId, allegatoId) =>
  apiClient.get(
    `/orders/ordini/${ordineId}/allegati/${allegatoId}/download/`,
    { responseType: 'blob' }
  )

// Archivio ordini (Punto 17 feedback cliente)
export const getOrdiniArchiviati = (params) =>
  apiClient.get('/orders/ordini/archiviati/', { params })

export const ripristinaOrdine = (id) =>
  apiClient.post(`/orders/ordini/${id}/ripristina/`)
